var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import { motion } from 'framer-motion';
import { varWrapEnter } from './variants';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
// ----------------------------------------------------------------------
const useStyles = makeStyles(() => ({
    root: {}
}));
export const MotionContainer = (_a) => {
    var { open, children, className } = _a, other = __rest(_a, ["open", "children", "className"]);
    const classes = useStyles();
    return (React.createElement(Box, Object.assign({ component: motion.div, initial: false, animate: open ? 'animate' : 'exit', variants: varWrapEnter, className: clsx(classes.root, className) }, other), children));
};
//# sourceMappingURL=MotionContainer.js.map